<div class="pickleball-court" [ngClass]="{'match-tbp': !matchStatus, 'table-tennis': discipline === 'TABLE_TENNIS', 'squash': discipline === 'SQUASH'}">
  <!-- Left Half -->
  <div class="court-half {{areSidesReveresed ? 'side2': 'side1'}}">
    <div class="service-area">
      <div class="top-service" [ngClass]="{'retuner-box': discipline === 'TABLE_TENNIS' ? 
                      isReturnerInPosition(areSidesReveresed ? 2 : 1, 'ad') : discipline === 'SQUASH' ? true : returningSide === 'AD'}">
        @if (topLeftPlayer?.showServerNumber && matchStatus) {
          <div class="server-number left-service-box-server-number">
              <div class="colored-icon"                    
                    [style.maskImage]="'url(' + ballIcon + ')'"
                    [style.webkitMaskImage]="'url(' + ballIcon + ')'"
                    [style.maskSize]="'contain'"
                    [style.webkitMaskSize]="'contain'"
                    [style.height]="'16px'"
                    [style.width]="'16px'"
                    role="img">
              </div>
                {{ serverNumber }}</div>
        }
        <span>{{ topLeftPlayer?.person?.first_name }}</span>        
        <span>{{ topLeftPlayer?.person?.last_name }}</span>        
      </div>
      <div class="bottom-service" [ngClass]="{'retuner-box': discipline === 'TABLE_TENNIS' ? 
                      isReturnerInPosition(areSidesReveresed ? 2 : 1, 'deuce') : discipline === 'SQUASH' ? false : returningSide === 'DEUCE'}">
        @if (bottomLeftPlayer?.showServerNumber && matchStatus) {
          <div class="server-number left-service-box-server-number">          
              <div class="colored-icon"                     
                    [style.maskImage]="'url(' + ballIcon + ')'"
                    [style.webkitMaskImage]="'url(' + ballIcon + ')'"
                    [style.maskSize]="'contain'"
                    [style.webkitMaskSize]="'contain'"
                    [style.height]="'16px'"
                    [style.width]="'16px'"
                    role="img">
              </div>
                {{ serverNumber }}</div>
        }
        <span> {{ bottomLeftPlayer?.person?.first_name }}</span>
        <span>{{ bottomLeftPlayer?.person?.last_name }}</span>
      </div>
    </div>
    <div class="kitchen-zone"></div>
  </div>

  <!-- Net -->
  <!-- <div class="net"></div> -->

  <!-- Right Half -->
  <div class="court-half {{areSidesReveresed ? 'side1': 'side2'}}">
    <div class="kitchen-zone"></div>

    <div class="service-area">
      <div class="top-service" [ngClass]="{'retuner-box': discipline === 'TABLE_TENNIS' ? 
                      isReturnerInPosition(areSidesReveresed ? 1 : 2, 'deuce') : discipline === 'SQUASH' ? true :
                      returningSide === 'DEUCE'}">
        @if (topRightPlayer?.showServerNumber && matchStatus) {
          <div class="server-number right-service-box-server-number">
              <div class="colored-icon"
                    [style.backgroundColor]="themeService.isDarkMode ? '#222428' : '#ffffff'"
                    [style.maskImage]="'url(' + ballIcon + ')'"
                    [style.webkitMaskImage]="'url(' + ballIcon + ')'"
                    [style.maskSize]="'contain'"
                    [style.webkitMaskSize]="'contain'"
                    [style.height]="'16px'"
                    [style.width]="'16px'"
                    role="img">
              </div>
            {{ serverNumber }}</div>
        }
        <span>{{ topRightPlayer?.person?.first_name }}</span>
        <span>{{ topRightPlayer?.person?.last_name }}</span>
      </div>
      <div class="bottom-service" [ngClass]="{'retuner-box': discipline === 'TABLE_TENNIS' ? 
                      isReturnerInPosition(areSidesReveresed ? 1 : 2, 'ad') : discipline === 'SQUASH' ? false :
              returningSide === 'AD'}">
        @if (bottomRightPlayer?.showServerNumber && matchStatus) {
          <div class="server-number right-service-box-server-number">
              <div class="colored-icon"
                    [style.backgroundColor]="themeService.isDarkMode ? '#222428' : '#ffffff'"
                    [style.maskImage]="'url(' + ballIcon + ')'"
                    [style.webkitMaskImage]="'url(' + ballIcon + ')'"
                    [style.maskSize]="'contain'"
                    [style.webkitMaskSize]="'contain'"
                    [style.height]="'16px'"
                    [style.width]="'16px'"
                    role="img">
              </div>
            {{ serverNumber }}</div>
        }
        <span>{{ bottomRightPlayer?.person?.first_name }}</span>
        <span>{{ bottomRightPlayer?.person?.last_name }}</span>
      </div>
    </div>
  </div>
</div>